var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearSky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.5C19.5899 22.5 22.5 19.5899 22.5 16C22.5 12.4101 19.5899 9.5 16 9.5C12.4101 9.5 9.5 12.4101 9.5 16C9.5 19.5899 12.4101 22.5 16 22.5Z",
    fill: "url(#paint0_linear_4805_26839)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1287 16.7573C24.4759 16.7573 24.7573 16.4759 24.7573 16.1287C24.7573 15.7815 24.4759 15.5 24.1287 15.5C23.7815 15.5 23.5 15.7815 23.5 16.1287C23.5 16.4759 23.7815 16.7573 24.1287 16.7573Z",
    fill: "#FDCA4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1287 24.7573C16.4759 24.7573 16.7573 24.4759 16.7573 24.1287C16.7573 23.7815 16.4759 23.5 16.1287 23.5C15.7815 23.5 15.5 23.7815 15.5 24.1287C15.5 24.4759 15.7815 24.7573 16.1287 24.7573Z",
    fill: "#FDCA4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1287 8.75733C16.4759 8.75733 16.7573 8.47587 16.7573 8.12867C16.7573 7.78146 16.4759 7.5 16.1287 7.5C15.7815 7.5 15.5 7.78146 15.5 8.12867C15.5 8.47587 15.7815 8.75733 16.1287 8.75733Z",
    fill: "#FDCA4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12867 16.7573C8.47587 16.7573 8.75734 16.4759 8.75734 16.1287C8.75734 15.7815 8.47587 15.5 8.12867 15.5C7.78146 15.5 7.5 15.7815 7.5 16.1287C7.5 16.4759 7.78146 16.7573 8.12867 16.7573Z",
    fill: "#FDCA4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1287 11.7573C10.4759 11.7573 10.7573 11.4759 10.7573 11.1287C10.7573 10.7815 10.4759 10.5 10.1287 10.5C9.78146 10.5 9.5 10.7815 9.5 11.1287C9.5 11.4759 9.78146 11.7573 10.1287 11.7573Z",
    fill: "#FDCA4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1287 11.7573C22.4759 11.7573 22.7573 11.4759 22.7573 11.1287C22.7573 10.7815 22.4759 10.5 22.1287 10.5C21.7815 10.5 21.5 10.7815 21.5 11.1287C21.5 11.4759 21.7815 11.7573 22.1287 11.7573Z",
    fill: "#FDCA4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1287 21.7573C22.4759 21.7573 22.7573 21.4759 22.7573 21.1287C22.7573 20.7815 22.4759 20.5 22.1287 20.5C21.7815 20.5 21.5 20.7815 21.5 21.1287C21.5 21.4759 21.7815 21.7573 22.1287 21.7573Z",
    fill: "#FDCA4F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1287 21.7573C10.4759 21.7573 10.7573 21.4759 10.7573 21.1287C10.7573 20.7815 10.4759 20.5 10.1287 20.5C9.78146 20.5 9.5 20.7815 9.5 21.1287C9.5 21.4759 9.78146 21.7573 10.1287 21.7573Z",
    fill: "#FDCA4F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_26839",
    x1: 11.4033,
    y1: 20.5935,
    x2: 20.5935,
    y2: 11.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSky);
export default __webpack_public_path__ + "static/media/clear_sky.0b73f6c5211553321eaf47bbe5aaad1f.svg";
export { ForwardRef as ReactComponent };